export enum LanguageKeys {
  en = 'en',
  bg = 'bg',
  zhCN = 'zh-CN',
  cs = 'cs',
  da = 'da',
  nl = 'nl',
  et = 'et',
  fi = 'fi',
  fr = 'fr',
  de = 'de',
  el = 'el',
  hu = 'hu',
  it = 'it',
  ja = 'ja',
  ko = 'ko',
  lv = 'lv',
  lt = 'lt',
  nb = 'nb',
  pl = 'pl',
  pt = 'pt',
  ro = 'ro',
  ru = 'ru',
  sr = 'sr',
  sl = 'sl',
  esES = 'es-ES',
  sv = 'sv',
}

export interface ILanguage {
  key: LanguageKeys;
  name: string;
  translate?: string;
}

export const EnLanguage = { key: LanguageKeys.en, name: 'English' };

export const Languages: ILanguage[] = [
  EnLanguage,
  { key: LanguageKeys.bg, name: 'Bulgarian', translate: 'Български' },
  { key: LanguageKeys.zhCN, name: 'Chinese', translate: '中文' },
  { key: LanguageKeys.cs, name: 'Czech', translate: 'Čeština' },
  { key: LanguageKeys.da, name: 'Danish', translate: 'Dansk' },
  { key: LanguageKeys.nl, name: 'Dutch', translate: 'Nederlands' },
  { key: LanguageKeys.et, name: 'Estonian', translate: 'Eestlane' },
  { key: LanguageKeys.fi, name: 'Finnish', translate: 'Suomalainen' },
  { key: LanguageKeys.fr, name: 'French', translate: 'Français' },
  { key: LanguageKeys.de, name: 'German', translate: 'Deutsch' },
  { key: LanguageKeys.el, name: 'Greek', translate: 'Ελληνικά' },
  { key: LanguageKeys.hu, name: 'Hungarian', translate: 'Magyar' },
  { key: LanguageKeys.it, name: 'Italian', translate: 'Italiano' },
  { key: LanguageKeys.ja, name: 'Japanese', translate: '日本語' },
  { key: LanguageKeys.ko, name: 'Korean', translate: '한국어' },
  { key: LanguageKeys.lv, name: 'Latvian', translate: 'Latvietis' },
  { key: LanguageKeys.lt, name: 'Lithuanian', translate: 'Lietuvis' },
  { key: LanguageKeys.nb, name: 'Norwegian Bokmål', translate: 'Norsk' },
  { key: LanguageKeys.pl, name: 'Polish', translate: 'Polskie' },
  { key: LanguageKeys.pt, name: 'Portuguese', translate: 'Português' },
  { key: LanguageKeys.ro, name: 'Romanian', translate: 'Română' },
  { key: LanguageKeys.ru, name: 'Russian', translate: 'Русский' },
  { key: LanguageKeys.sr, name: 'Serbian', translate: 'Srpski' },
  { key: LanguageKeys.sl, name: 'Slovenian', translate: 'Slovenščina' },
  { key: LanguageKeys.esES, name: 'Spanish', translate: 'Español' },
  { key: LanguageKeys.sv, name: 'Swedish', translate: 'Svenska' },
];